import { dataLayerEventExist } from './site/helpers';

document.addEventListener('DOMContentLoaded', function () {
    const masonryItems = document.querySelectorAll('.masonry-item');

    masonryItems.forEach((item) => {
        const itemTitle = item.querySelector('h3').innerText;
        let hoverTimer;

        item.addEventListener('mouseenter', function () {
            hoverTimer = setTimeout(() => {
                if (!dataLayerEventExist('masonryItemHover', itemTitle)) {
                    window.dataLayer.push({
                        event: 'masonryItemHover',
                        eventLabel: itemTitle
                    });
                }
            }, 2000);
        });

        item.addEventListener('mouseleave', function () {
            clearTimeout(hoverTimer);
        });

        // mobile
        item.addEventListener('touchstart', function () {
            if (!dataLayerEventExist('masonryItemHover', itemTitle)) {
                window.dataLayer.push({
                    event: 'masonryItemHover',
                    eventLabel: itemTitle
                });
            }
        });
    });
});
